import { styled } from "@mui/material";
import { columnsMap } from "./columns";
import { SearchAndSelectColumnId } from "./SearchAndSelectColumnId";
import { TableCell } from "@kaltura/ds-react-components";
import { TableRow } from "@kaltura/mediaspace-shared-styled";

export const StyledTableCell = styled(
    TableCell,
    {
        shouldForwardProp: (propName) => propName !== "columnId" && propName !== "columnWidth",
    }
)<{ columnId: SearchAndSelectColumnId; columnWidth?: number | string }>(({ theme, columnId, columnWidth }) => ({
    width: columnWidth !== undefined ? columnWidth : columnsMap[columnId].width,
    maxWidth: columnWidth !== undefined ? columnWidth : columnsMap[columnId].width,
    minWidth:
        columnWidth !== undefined
        && Number(columnWidth) < Number(columnsMap[columnId].minWidth ?? columnsMap[columnId].width)
            ? columnWidth
            : columnsMap[columnId].minWidth ?? columnsMap[columnId].width,
    borderBottomColor: theme.kaltura.palette.tone5,
    "&:first-of-type": {
        paddingLeft: theme.spacing(2),
    },
    "&:last-of-type": {
        paddingRight: theme.spacing(2),
    },
}));

export const StyledCheckboxTableCell = styled(TableCell)(({ theme }) => ({
    borderBottomColor: theme.kaltura.palette.tone5,

    "&:first-of-type": {
        paddingLeft: theme.spacing(2),
    },
}));
export const TableCellNoBorder = styled(TableCell)({
    borderBottom: "none",
});

export const actionsColumnWidth = 180;
export const StyledActionsTableCell = styled(
    TableCell,
    {
        shouldForwardProp: (propName) => propName !== "stickyWidth",
    }
)<{ stickyWidth?: number }>(({ theme, stickyWidth = actionsColumnWidth }) => ({
    width: stickyWidth,
    maxWidth: stickyWidth,
    minWidth: stickyWidth,
    borderBottomColor: theme.kaltura.palette.tone5,
    "&:first-of-type": {
        paddingLeft: theme.spacing(2),
    },
    "&:last-of-type": {
        paddingRight: theme.spacing(2),
    },
}));

export const StyledActionsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    justifyContent: "flex-end",
}));

export const StyledMessagesContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    rowGap: theme.spacing(2),
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "& .mediatablecell:first-of-type": {
        paddingLeft: theme.spacing(2),
    },
    "& .mediatablecell:last-of-type": {
        paddingRight: theme.spacing(2),
    },
}));
